import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    siteKey: String,
    action: String,
    cspNonce: String
  }

  connect() {
    this.loadRecaptcha()
  }

  loadRecaptcha() {
    const script = document.createElement("script")
    script.src = `https://www.google.com/recaptcha/api.js?render=${this.siteKeyValue}`

    if (this.hasCspNonceValue) script.nonce = this.cspNonceValue
    script.onload = () => {
      grecaptcha.ready(() => {
        this.getToken()
      })
    }

    document.head.appendChild(script)
  }

  getToken() {
    grecaptcha.execute(this.siteKeyValue, { action: this.actionValue }).then(token => {
      const inputId = `g-recaptcha-response-data-${this.actionValue}`
      const inputElement = document.getElementById(inputId)
      if (inputElement) {
        inputElement.value = token
      }
    })
  }
}
